module.exports = __webpack_public_path__ + "static/img/Ai2.f13bdd5b.png";